var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-2d601e23-2e66-491b-bde1-e697420b8104",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .uuid-81edf4fe-d768-4577-9864-5f258ff05b41 {\n        fill: #f2f2f2;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "uuid-81edf4fe-d768-4577-9864-5f258ff05b41",
    d: "M19.66,21.94h-7.33c-1.26,0-2.28-1.02-2.28-2.28v-7.33c0-1.26,1.02-2.28,2.28-2.28h7.33c1.26,0,2.28,1.02,2.28,2.28v7.33c0,1.26-1.02,2.28-2.28,2.28ZM12.34,12.06c-.16,0-.28.13-.28.28v7.33c0,.16.13.28.28.28h7.33c.16,0,.28-.13.28-.28v-7.33c0-.16-.13-.28-.28-.28h-7.33Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStop);
export default __webpack_public_path__ + "static/media/Stop.ebd46fe1dc79fddd277d6314f612204e.svg";
export { ForwardRef as ReactComponent };